import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "member_details_body"
};
const _hoisted_2 = {
  class: "navbat"
};
const _hoisted_3 = {
  style: {
    "margin-bottom": "50px",
    "margin-top": "20px",
    "text-align": "center"
  }
};
const _hoisted_4 = {
  style: {
    "display": "flex",
    "justify-content": "center",
    "width": "100%"
  },
  class: "nr_data"
};
const _hoisted_5 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/imgs/fh.png",
    alt: "",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.fh && $setup.fh(...args))
  }), _cache[1] || (_cache[1] = _createElementVNode("span", null, "详情", -1))]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_3, [_createElementVNode("h1", null, _toDisplayString($setup.get_data.caseTitleName), 1)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("p", {
    innerHTML: $setup.get_data.caseIntroduce,
    style: {
      "margin-bottom": "100px",
      "width": "80%"
    }
  }, null, 8, _hoisted_5)])])]);
}